fragment AccessGroupsFields on AccessGroup {
  __typename
  id
  name
  description
  _rowTimestamp
  _isUpdatable
  _isDeletable
  accessGroupItems(orderBy: USER_GROUP_BY_USER_GROUP_ID__NAME_ASC) {
    nodes {
      id
      _rowTimestamp
      userGroupId
      userGroup {
        name
        id
        _rowTimestamp
      }
      _isDeletable
    }
  }
}
